import React from 'react';
import { Link } from 'react-router-dom';
import './ISO22000.css';

const ISO22000 = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="page-main">
          <section className="page-section">
            <div className="page-breadcrumb">System Certification</div>
            <h1 className="page-title">ISO 22000 Food Safety Management System</h1>
            <h2 className="page-subtitle">Food Safety with NQC: Pursuing Quality with ISO 22000</h2>
            <div className="page-text-content">
              <p>
                NQC (Nova Quality Certification Agency) provides significant services for organizations 
                operating in the food industry, and one of the essential services we offer is the ISO 
                22000 Food Safety Management System, which provides a framework for reliable and safe 
                food production. This system encompasses a comprehensive approach designed to assess, 
                control, and monitor risks throughout the food chain.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">What is ISO 22000?</h2>
            <div className="page-text-content">
              <p>
                ISO 22000 is an international standard that defines the Food Safety Management System 
                (FSMS) for organizations operating in the food industry. This standard provides guidance 
                for managing food safety processes effectively, controlling food safety risks, and 
                supplying safe food to consumers.
              </p>
              <p>
                ISO 22000 aims to help organizations establish, implement, maintain, and continually 
                improve their food safety management systems. Based on the principles of Hazard Analysis 
                and Critical Control Points (HACCP), it provides a framework for safe food production 
                across all stages of the supply chain.
              </p>
              <p>
                ISO 22000 standards cover a wide range of topics necessary for safe food production. The 
                standard includes elements such as assessing food safety risks, identifying critical control 
                points, compliance with legal requirements, creating awareness through education, ensuring 
                traceability, and transparent communication.
              </p>
              <p>
                By adhering to ISO 22000 standards, organizations can gain customer confidence, ensure 
                legal compliance, enhance operational efficiency, and contribute to reliable food production 
                throughout the supply chain. By providing a comprehensive framework for establishing and 
                maintaining a food safety management system, the standard helps organizations gain a 
                competitive advantage over other players in the industry.
              </p>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Key Elements of ISO 22000:</h2>
            <div className="elements-list">
              <div className="element-item">
                <h3 className="element-title">HACCP Principles</h3>
                <p className="element-description">
                  ISO 22000 recommends organizations to adopt HACCP principles to effectively assess 
                  food safety risks and identify critical control points.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">Legal Compliance and Standards</h3>
                <p className="element-description">
                  Organizations must stay updated and maintain compliance with relevant legal regulations 
                  and ISO 22000 standards.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">Traceability and Transparent Communication</h3>
                <p className="element-description">
                  ISO 22000 encourages traceability of food products throughout the supply chain and 
                  promotes transparent flow of information.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">Training and Awareness</h3>
                <p className="element-description">
                  Employee training and awareness play a critical role in the successful implementation 
                  of food safety processes.
                </p>
              </div>
              <div className="element-item">
                <h3 className="element-title">Good Manufacturing Practices (GMP) and Hygiene</h3>
                <p className="element-description">
                  ISO 22000 provides a strong foundation for organizations by including operational good 
                  practices and hygiene standards.
                </p>
              </div>
            </div>
          </section>

          <section className="page-section">
            <h2 className="page-section-title">Advantages of ISO 22000 Certification:</h2>
            <div className="advantages-list">
              <div className="advantage-item">
                <h3 className="advantage-title">Customer Confidence</h3>
                <p className="advantage-description">
                  ISO 22000 certification builds trust with customers by committing to reliable and 
                  safe food production.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Competitive Advantage</h3>
                <p className="advantage-description">
                  The certification helps organizations gain a competitive edge over other industry players.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Supply Chain Security</h3>
                <p className="advantage-description">
                  ISO 22000 supports safe food production throughout the supply chain, enhancing 
                  collaboration and trust among partners.
                </p>
              </div>
              <div className="advantage-item">
                <h3 className="advantage-title">Operational Efficiency</h3>
                <p className="advantage-description">
                  The standard offers the potential to make business processes more effective and 
                  efficient, reducing waste and improving productivity.
                </p>
              </div>
            </div>
            <div className="page-text-content">
              <p>
                At NQC (Nova Quality Certification Agency), we support you in perfecting your processes 
                related to the ISO 22000 Food Safety Management System with our commitment to providing 
                reliable and quality services. This critical standard for food safety can help you stand 
                out in the industry.
              </p>
            </div>
          </section>
        </div>

        <aside className="page-sidebar">
          <div className="sidebar-section">
            <h2 className="sidebar-title">Our Services</h2>
            <ul className="sidebar-links">
              <li><Link to="/system-certification">System Certification</Link></li>
              <li><Link to="/product-certification">Product Certification</Link></li>
              <li><Link to="/quality-certification">Quality Certification</Link></li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default ISO22000;

